<h1 class="page-header">NordNative Documentation</h1>
<div class="col-xs-12" style="height:50px;"></div>

<div class="container">
    <div class="card-deck">
        <div class="card">
            <div class="card-body">
                <h2 class="card-title">NordNative Auth Service Documentation</h2>
                <a href="https://nordnative.com/docs/nn-auth/1.0" target="_blank">User Guide</a> (Latest)
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <h2 class="card-title">BunnyCRM Documentation</h2>
                <h3>Newsletter Subscription System</h3>
                <ul>
                    <li><a href="https://bunnycrm.com/docs/newsletter-subscription-management/1.0/" target="_blank">User
                            Guide</a> (Latest)</li>
                    <!-- <li><a href="https://bunnycrm.com/docs/newsletter-subscription-management/1.0/api-ref/" target="_blank">API Reference</a> (Latest)</li> -->
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="col-xs-12" style="height:50px;"></div>